import Vue from 'vue'

import { getSocket } from '@/utils'

import render from './render'

export default {
  name: 'Connection',

  data() {
    const socket = getSocket()

    return {
      ws: {
        connected: socket?.connected,
        error: undefined
      }
    }
  },

  mounted() {
    const socket = getSocket()
    socket?.on('connect', () => {
      return Vue.set(this.ws, 'connected', true)
    })
    socket?.on('disconnect', () => {
      return Vue.set(this.ws, 'connected', false)
    })
    socket?.on('error', error => {
      return Vue.set(this.ws, 'error', error)
    })

    setInterval(() => {
      Vue.set(this.ws, 'connected', getSocket()?.connected)
    }, 5 * 1000)
  },

  render
}
